import {formatDate} from 'utils/format'
import {DATA_MAP} from 'constants'

export const convertList = (list: any, timeLabel: string = 'insertTime') =>
  list
    ? [
      ...(list
          && list.map(v => ({
            ...v,
            sortTime: v[timeLabel],
            [timeLabel]: formatDate(v[timeLabel])
          })))
    ]
    : []

export const sortList = (list: any) => list && list.sort((a, b) => b.sortTime - a.sortTime)

export const convertType = (l, v) => (l === 'cn' ? DATA_MAP[v] || v : v)
